<section class="order-container" id="stopenlinea-order">
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right">
        <div class="title-name">Duración</div>
      </div>
    </div>
    <div
      punchPicker
      [isTitles]="true"
      (items)="setTitles($event)"
      [sentValue]="titles"
      data-recording-ignore="mask"
    ></div>
    <div
      class="combo-select-wrapper enlinea"
      *ngIf="canModifyDuration === true"
    >
      <combo-select
        [class]="'duration'"
        [sentSelected]="defaultDuration"
        class="small"
        [resultsList]="vigencia"
        [title]="'Duración'"
        (emitSelectedItem)="setDuration($event)"
      >
      </combo-select>
    </div>
    <div class="hard-section" *ngIf="canModifyDuration === false">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Precio stop</div>
      </div>
    </div>
    <div
      punchPicker
      [class]="'prc-stop'"
      [placeholder]="'Precio stop'"
      class="full"
      [sentValue]="selectedPrice"
      [isPrice]="true"
      (items)="setStopPrice($event)"
      [minValue]="0"
      data-recording-ignore="mask"
    ></div>
  </div>
  <div class="actions" *ngIf="canOperate && !isDiscretional">
    <button (click)="tryBuy()" class="btn-compra">
      <div class="button button--loading" *ngIf="isBuyButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isBuyButtonLoading ? '' : 'Comprar' }}
    </button>
    <button (click)="trySell()" class="btn-venta">
      <div class="button button--loading" *ngIf="isSellButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isSellButtonLoading ? '' : 'Vender' }}
    </button>
  </div>
</section>
<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
